import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Header from './components/admin/layout/Header';
import SubHeader from './components/admin/layout/SubHeader';
import { logOut } from './actions/authentication';
import { fetchOptions, switchContext } from './actions/admin/context';
import * as contextSelectors from './selectors/admin/context';
import { currentPath } from './selectors/router';
import Flash from './components/admin/helpers/Flash';
import { closeFlash } from './actions/admin/flash';
import { flashMessageSelector, flashTypeSelector } from './selectors/admin/flash';
import SideBar from './components/admin/layout/SideBar';
import { breadcrumbSelector } from './selectors/admin/breadcrumb';

class AdminLayout extends Component {
    render() {
        return (
            <div className="ckp-admin-layout u-full-height">
                <Header logOut={this.props.logOut} currentPath={this.props.currentPath} />
                <SubHeader
                    breadcrumb={this.props.breadcrumb}
                    contextName={this.props.contextName}
                    subject={this.props.contextSubject}
                    contextReady={this.props.contextReady}
                    organizations={this.props.contextOptions}
                    switchContext={this.props.switchContext}
                    fetchOptions={this.props.fetchOptions}
                />
                <div className={`ckp-admin-layout-body`}>
                    <div className={`ckp-admin-layout-left`}>
                        <SideBar
                            subject={this.props.contextSubject}
                            currentPath={this.props.currentPath}
                            hasContext={this.props.hasContext}
                        />
                    </div>
                    <div className="ckp-admin-layout-right">
                        <main className="ckp-admin-layout-main">
                            <Flash
                                message={this.props.flash}
                                flashType={this.props.flashType}
                                close={this.props.closeFlash}
                            />
                            {this.props.children}
                        </main>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    contextOptions: contextSelectors.contextOptionsSelector(state),
    contextSubject: contextSelectors.contextSubjectSelector(state),
    contextReady: contextSelectors.contextReadySelector(state),
    contextName: contextSelectors.contextNameSelector(state),
    currentPath: currentPath(state),
    flash: flashMessageSelector(state),
    flashType: flashTypeSelector(state),
    hasContext: contextSelectors.hasContextSelector(state),
    breadcrumb: breadcrumbSelector(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ logOut, fetchOptions, switchContext, closeFlash }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);



// WEBPACK FOOTER //
// ./src/AdminLayout.js